import {apiClient} from './apiClient';
import {LoginCredentials, LoginResponse} from './auth';

export const authApi = {
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>('/login', credentials);
    return response.data;
  },
};
